import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { UserCog, ArrowLeftCircle } from "lucide-react";

export default function ImpersonationBanner() {
  const { user, impersonator, stopImpersonation } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  if (!impersonator || !user) return null;

  const who = (user.first_name || user.last_name)
    ? `${user.first_name || ""} ${user.last_name || ""}`.trim()
    : user.email;

  const back = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await stopImpersonation();
      toast.success("Retour à votre compte administrateur");
      navigate("/admin/utilisateurs");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Impossible de revenir au compte admin");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <div className="fixed top-0 inset-x-0 z-[70] bg-amber-500 text-slate-900 shadow-md" data-testid="impersonation-banner">
        <div className="max-w-6xl mx-auto px-3 py-2 flex items-center gap-3 text-sm">
          <UserCog size={18} className="shrink-0" />
          <span className="min-w-0 flex-1 truncate">
            Connecté en tant que <strong className="font-bold">{who}</strong>
            <span className="hidden sm:inline"> — vos actions modifient réellement ce compte.</span>
          </span>
          <button
            onClick={back}
            disabled={busy}
            data-testid="impersonation-stop-btn"
            className="shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-slate-900 text-white text-xs font-bold hover:bg-slate-800 disabled:opacity-60"
          >
            <ArrowLeftCircle size={15} />
            Revenir à mon compte admin
          </button>
        </div>
      </div>
      {/* Décale le contenu pour ne pas masquer le header du compte cible */}
      <div className="h-10" aria-hidden="true" />
    </>
  );
}
